import jpg from './plane-desktop.jpg'
import jpg2x from './plane-desktop@2x.jpg'
import webp from './plane-desktop.webp'
import webp2x from './plane-desktop@2x.webp'

const index = {
  jpg,
  jpg2x,
  webp,
  webp2x,
}

export default index
